import React from 'react'

import './Form.css'

import IconOption from '../components/IconOption'
import ListOption from '../components/ListOption'

import packageImg from '../assets/package.svg'
import { appTypesAsList, deploymentAsList, getFrameworks, repoAsList } from '../config'

function Form () {
	const [appType, setAppType] = React.useState('')
	const [framework, setFramework] = React.useState('')
	const [repo, setRepo] = React.useState('')
	const [deployment, setDeployment] = React.useState('')

	const frameworks = getFrameworks(appType)

	const scrollTo = (elementId) => {
		document.getElementById(elementId).scrollIntoView({
			behavior: 'smooth'
		})
	}

	return (
		<main className="max-h-screen">
			<section id="appType" className="page-section pipes1 relative">
				{/* Draw Pipes */}
				<img
					id="package"
					className="object-fill absolute max-w-screen max-h-screen animate-package"
					style={{ top: 5, right: 58, zIndex: 100 }}
					src={packageImg}
					alt=""
				/>
				<div
					className="absolute bg-gray-300 p-10"
					style={{ right: 50, top: 0, bottom: 50, zIndex: -100 }}
				/>
				<div
					className="absolute bg-gray-300 p-10"
					style={{ left: 0, bottom: 50, right: 50, zIndex: -100 }}
				/>
				<div
					className="absolute bg-gray-300 p-10"
					style={{ left: 0, bottom: 0, zIndex: -100 }}
				/>
				<div
					className="absolute bg-gray-500 py-3 px-12"
					style={{ right: 40, top: 100, zIndex: -100 }}
				/>
				{/* End Pipes */}

				<div className="container p-40">
					<h1 className="text-5xl font-bold pb-4">Start a NoOps Boilerplate</h1>
					<h2 className="text-3xl font-light">Choose the application type you want to build</h2>

					<div className="flex flex-row flex-wrap gap-4 py-20 mx-40">
						{appTypesAsList.map((data) => (
							<IconOption
								key={data.id}
								selected={data.id === appType}
								data={data}
								type="appTypes"
								onSelect={(id) => {
									setAppType(id)
									scrollTo("language")
								}}
							/>
						))}
					</div>
				</div>
			</section>

			<section id="language" className="page-section relative">
				{/* Draw Pipes */}
				<img
					id="package"
					className="object-fill absolute max-w-screen max-h-screen animate-package"
					style={{ top: 20, left: 8, zIndex: 100 }}
					src={packageImg}
					alt=""
				/>
				<div
					className="absolute bg-gray-300 p-10"
					style={{ left: 0, top: 0, bottom: 0, zIndex: -100 }}
				/>
				<div
					className="absolute bg-gray-500 py-3 px-12"
					style={{ left: -10, top: 100, zIndex: -100 }}
				/>
				{/* End Pipes */}

				<div className="absolute right-1/2 top-10">
					<button className="text-2xl" onClick={() => scrollTo("appType")}>
						<h3>Go back</h3>
					</button>
				</div>

				<div className="container ml-40 p-40">
					<h1 className="text-5xl font-bold pb-4">Choose the programming language</h1>
					<h2 className="text-3xl font-light">Or the framework/tool yo want to use</h2>

					{/* https://devicon.dev/ */}
					<div className="flex flex-col flex-nowrap gap-3 px-5 m-20 max-w-md max-h-96 overflow-auto">
						{frameworks.map((data) => (
							<ListOption
								key={data.id}
								selected={data.id === framework}
								data={data}
								type="frameworks"
								onSelect={(id) => {
									setFramework(id)
									scrollTo("repo")
								}}
							/>
						))}
					</div>
				</div>
			</section>

			<section id="repo" className="page-section relative">
				{/* Draw Pipes */}
				<img
					id="package"
					className="object-fill absolute max-w-screen max-h-screen animate-package"
					style={{ top: 20, left: 8, zIndex: 100 }}
					src={packageImg}
					alt=""
				/>
				<div
					className="absolute bg-gray-300 p-10"
					style={{ left: 0, top: 0, bottom: 0, zIndex: -100 }}
				/>
				<div
					className="absolute bg-gray-500 py-3 px-12"
					style={{ left: -10, top: 100, zIndex: -100 }}
				/>
				{/* End Pipes */}

				<div className="absolute right-1/2 top-10">
					<button className="text-2xl" onClick={() => scrollTo("language")}>
						<h3>Go back</h3>
					</button>
				</div>

				<div className="container ml-40 p-40">
					<h1 className="text-5xl font-bold pb-4">Where it will be hosted?</h1>
					<h2 className="text-3xl font-light">Choose the git repo provider</h2>

					{/* https://devicon.dev/ */}
					<div className="flex flex-row flex-wrap gap-4 py-20 mr-20 max-w-lg">
						{repoAsList.map((data) => (
							<IconOption
								key={data.id}
								selected={data.id === repo}
								data={data}
								type="repo"
								onSelect={(id) => {
									setRepo(id)
									scrollTo("deployment")
								}}
							/>
						))}
					</div>
				</div>
			</section>

			<section id="deployment" className="page-section relative">
				{/* Draw Pipes */}
				<img
					id="package"
					className="object-fill absolute max-w-screen max-h-screen animate-package"
					style={{ top: 20, left: 8, zIndex: 100 }}
					src={packageImg}
					alt=""
				/>
				<div
					className="absolute bg-gray-300 p-10"
					style={{ left: 0, top: 0, bottom: 0, zIndex: -100 }}
				/>
				<div
					className="absolute bg-gray-500 py-3 px-12"
					style={{ left: -10, top: 100, zIndex: -100 }}
				/>
				{/* End Pipes */}

				<div className="absolute right-1/2 top-10">
					<button className="text-2xl" onClick={() => scrollTo("repo")}>
						<h3>Go back</h3>
					</button>
				</div>

				<div className="container ml-40 p-40">
					<h1 className="text-5xl font-bold pb-4">How it will be deployed?</h1>
					<h2 className="text-3xl font-light">Choose the cloud provider</h2>

					{/* https://devicon.dev/ */}
					<div className="flex flex-row flex-wrap gap-4 py-20 mr-20 max-w-lg">
						{deploymentAsList.map((data) => (
							<IconOption
								key={data.id}
								selected={data.id === deployment}
								data={data}
								type="deployment"
								onSelect={(id) => {
									setDeployment(id)
									scrollTo("appType")
								}}
							/>
						))}
					</div>
				</div>
			</section>
		</main>
	)
}

export default Form
